<template>
    <CatalogAttributeItemMultiAutocomplete v-if="attribute.is_multiple" :attribute="attribute" :integration="integration" :category="category" :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" />
    <CatalogAttributeItemSingleAutocomplete v-else :attribute="attribute" :integration="integration" :category="category" :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" />
</template>

<script>
import CatalogAttributeItemMultiAutocomplete from "./CatalogAttributeItemMultiAutocomplete.vue";
import CatalogAttributeItemSingleAutocomplete from "./CatalogAttributeItemSingleAutocomplete.vue";

export default {
    name: "CatalogAttributeSelect",
    components: { CatalogAttributeItemMultiAutocomplete, CatalogAttributeItemSingleAutocomplete },
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
        attribute: {
            type: Object,
            required: true,
        },
        integration: {
            type: Object,
            required: true,
        },
        category: {
            type: Object,
            required: true,
        },
    },
}
</script>
